import { render, staticRenderFns } from "./SurveyTable.vue?vue&type=template&id=218e4950&scoped=true"
import script from "./SurveyTable.vue?vue&type=script&lang=js"
export * from "./SurveyTable.vue?vue&type=script&lang=js"
import style0 from "./SurveyTable.vue?vue&type=style&index=0&id=218e4950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218e4950",
  null
  
)

export default component.exports